<template>
  <FormGroup v-if="values" class="mt-6">
    <FormField class="sm:col-span-6" field="practice_id" :errors="errors">
      <template #label>
        <ExperimentPracticeTooltip />
      </template>
      <template #input="props">
        <SelectPractice v-model="values.practice_id" id="practice_id" :class="props['class']" />
      </template>
    </FormField>
    <FormField class="sm:col-span-6" field="title" :errors="errors">
      <template #label>
        <ExperimentTitleTooltip />
      </template>
      <template #input="props">
        <InputText v-model="values.title" id="title" :class="props['class']"/>
      </template>
    </FormField>
    <FormField class="sm:col-span-3" field="starts_at" :errors="errors">
      <template #label>
        <ExperimentStartsAtTooltip />
      </template>
      <template #input="props">
        <InputDate v-model="values.starts_at" id="starts_at" :class="props['class']" />
      </template>
    </FormField>
    <FormField class="sm:col-span-3" field="ends_at" :errors="errors">
      <template #label>
        <ExperimentEndsAtTooltip />
      </template>
      <template #input="props">
        <InputDate v-model="values.ends_at" id="ends_at" :class="props['class']" />
      </template>
    </FormField>
    <FormField class="sm:col-span-6" field="notes" :errors="errors">
      <template #label>
        <ExperimentRemarksTooltip />
      </template>
      <template #input="props">
        <Textarea v-model="values.notes" id="notes" :class="props['class']" />
      </template>
    </FormField>
  </FormGroup>
</template>

<script setup>
import { computed, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { useRetrieveResource } from '@/client/actions';
import { DateTime } from 'luxon';

const props = defineProps({resource: Object, errors: Object});
const store = useStore();
const values = ref(props.resource);

const context = computed(() => store.getters['context/context'].id);
const parent = computed(() => values.value.practice_id);

const target = computed(() => '/api/practices/' + parent.value);
const params = computed(() => ({context: context.value}));

const action = useRetrieveResource(target, params.value);

const { resource: practice, retrieve, retrieving } = action;

const changed = (id) => retrieve();
const watcher = watch(parent, changed);

const update = watch(practice, (value) =>
{
  if(value)
  {
    const date_from = DateTime.fromISO(practice.value.date_from);
    const date_till = DateTime.fromISO(practice.value.date_till);
    const date_format = (date) => date.isValid ? date.toFormat('yyyy-MM-dd') : undefined;
    props.resource.starts_at = date_format(date_from);
    props.resource.ends_at = date_format(date_till);
  }
});
</script>
